module.exports = __webpack_public_path__ + "img/21.02cec704.jpg";